import React from "react";
import { LayoutMain } from "@unisearch/theme/layout";
import {
  ElearningHomeHero2,
  ElearningHomeCount,
  ElearningDemoBooking,
  ElearningHomeIntro,
  ElearningHomeOnlineTest,
  ElearningDemoFree,
  ElearningTechnologySuccess,
  ElearningHomeStats,
} from "@modules/elearning/home";

import {
  FAQSection,
  InstructionDownload,
  ClientReview,
} from "@modules/study/common/sections";

import faqData from "@_fakeData/faq.json";

const Elearning = () => {
  return (
    <LayoutMain
      footer_with_evaluation
      title="eLearning"
      metaUrl={`${process.env.NEXT_PUBLIC_URL}/elearning/home`}
    >
      <ElearningHomeHero2 />
      <ElearningHomeCount />
      <InstructionDownload
        heading={`<span className="mark">Get Free</span> Counseling to Discover <br/> The Right Course For You`}
        shortDescription="Tellus augue sit aenean eu tristique eu viverra."
        buttonTitle="Talk to Expart"
        link="#"
        as="video-link"
      />
      <ElearningDemoBooking />
      <ElearningHomeIntro />
      <ElearningHomeOnlineTest />
      <ElearningDemoFree />
      <ElearningTechnologySuccess />
      <ElearningHomeStats />
      <ClientReview />
      <FAQSection faqData={faqData} title="Frequently Asked Questions" />
    </LayoutMain>
  );
};

export default Elearning;
